function getLaunchdarklyClientId() {
  return process.env.LAUNCHDARKLY_CLIENT_ID;
}

export { getLaunchdarklyClientId };